/**
 * An error that represents that the AWS Api url is undefined. This is likely because
 * the environment variable GATSBY_AWS_API_URL does not exist.
 */
export class ApiUrlUndefinedError extends Error {
  constructor() {
    super('AWS Api url is not set.');
  }
}
